"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styles_1 = require("../../styles");

var Flow_1 = require("../Flow");

var MonthControl_1 = require("./MonthControl");

var MonthView_1 = require("./MonthView");

var util_1 = require("./util");

var YearControl_1 = require("./YearControl");

function Calendar(props) {
  var initialVisibleDate = props.initialVisibleDate,
      modifiers = props.modifiers,
      modifierStyles = props.modifierStyles,
      rest = __rest(props, ["initialVisibleDate", "modifiers", "modifierStyles"]);

  var _a = styles_1.useStyles(exports.createStyles),
      classes = _a.classes,
      theme = _a.theme;

  var _b = react_1.useState(initialVisibleDate),
      visibleDate = _b[0],
      setVisibleDate = _b[1];

  var allModifiers = function allModifiers() {
    return __assign({}, exports.defaultModifiers, modifiers);
  };

  var allModifierStyles = function allModifierStyles() {
    return __assign({}, exports.defaultModifierStyles, modifierStyles);
  };

  var handleDayClick = function handleDayClick(day) {
    if (!allModifiers().disabled(day, props)) {
      setVisibleDate(day);
      return props.onDayClick && props.onDayClick(day);
    }
  };

  return react_1.default.createElement("div", {
    className: classes.root
  }, react_1.default.createElement(Flow_1.HFlow, {
    hSpacing: 0.5,
    justifyContent: 'space-around',
    style: classes.controls
  }, react_1.default.createElement(MonthControl_1.MonthControl, {
    visibleDate: visibleDate,
    onChange: setVisibleDate
  }), react_1.default.createElement(YearControl_1.YearControl, {
    visibleDate: visibleDate,
    onChange: setVisibleDate
  })), react_1.default.createElement(MonthView_1.MonthView, __assign({
    createDayStyles: exports.createDayStyles(allModifiers(), allModifierStyles(), theme)
  }, rest, {
    visibleDate: visibleDate,
    onDayClick: handleDayClick
  })));
}

exports.Calendar = Calendar;
Calendar.defaultProps = {
  initialVisibleDate: new Date()
};

exports.createStyles = function () {
  return {
    root: {
      width: 288
    },
    controls: {
      marginBottom: '0.5rem',
      fontWeight: 'bold'
    }
  };
};

exports.defaultModifiers = {
  today: function today(day) {
    return util_1.isSameDay(new Date(), day);
  },
  disabled: function disabled() {
    return false;
  },
  selected: function selected() {
    return false;
  },
  adjacentMonth: function adjacentMonth(day, _a) {
    var visibleDate = _a.visibleDate;
    return visibleDate.getMonth() !== day.getMonth();
  }
};
exports.defaultModifierStyles = {
  today: function today() {
    return {
      fontWeight: 'bold'
    };
  },
  disabled: function disabled(theme) {
    return {
      color: theme.pallete.text.disabled,
      ':hover': {
        background: 'initial',
        cursor: 'not-allowed'
      }
    };
  },
  selected: function selected(theme) {
    return {
      background: theme.pallete.primary.main,
      color: theme.pallete.surface.main,
      fontWeight: 'bold',
      ':hover': {
        background: theme.pallete.primary.main,
        color: theme.pallete.surface.main
      }
    };
  },
  adjacentMonth: function adjacentMonth(theme) {
    return {
      color: theme.pallete.text.disabled
    };
  }
};

exports.createDayStyles = function (modifiers, styles, theme) {
  return function (day, props) {
    return Object.keys(modifiers).reduce(function (s, modifier) {
      if (!styles[modifier]) {
        throw new Error("You must provied a modifierStyle for predicate \"" + modifier + "\"");
      }

      return __assign({}, s, modifiers[modifier](day, props) ? styles[modifier](theme) : {});
    }, {});
  };
};